var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.34103 13.2402C7.27253 13.1786 7.23828 13.0998 7.23828 13.0039C7.23828 12.908 7.28623 12.7984 7.38214 12.6751L12.9308 5.70842C13.0404 5.57141 13.1603 5.50633 13.2904 5.51318C13.4206 5.51318 13.5199 5.56799 13.5884 5.67759C13.6569 5.78034 13.6603 5.91392 13.5987 6.07833L11.7389 11.0721H15.1708C15.2804 11.0721 15.366 11.1029 15.4277 11.1646C15.4962 11.2194 15.5304 11.2982 15.5304 11.4009C15.5304 11.4968 15.4825 11.603 15.3866 11.7195L9.83793 18.6964C9.72833 18.8265 9.60845 18.8916 9.4783 18.8916C9.34814 18.8916 9.24881 18.8402 9.18031 18.7375C9.11181 18.6279 9.10838 18.4875 9.17004 18.3162L11.0299 13.3224H7.58764C7.49174 13.3224 7.40954 13.295 7.34103 13.2402Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1.0127,
    width: 23,
    height: 23,
    rx: 11.5,
    stroke: "white",
    strokeOpacity: 0.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlash);
export default __webpack_public_path__ + "static/media/flash.eab3b7906c21871932325d0443a55ba0.svg";
export { ForwardRef as ReactComponent };